module.exports = __webpack_public_path__ + "img/PEARLSAsset 211.1a48f5a.svg";